// ##### Komarov 2025-07-24
import uniqueId from 'lodash.uniqueid';
// ##### 25-04-30 Komarov
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectDeviceType } from '../../../../Redux/selectors';
// ##### 25-04-18 Komarov
import { getLoadedPage } from '../../../../Redux/actions';
// ##### 25-03-27 Komarov
import { Media } from '../../../../helpers/MediaConfig';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../../../server/helpers/uniLog';
// ##### Komarov 2025-07-25
import CarouselSlider from '../../../Library/Slider/CarouselSlider';
// ##### Komarov 2025-08-21
import { usePerformanceMeasure } from '../../../../hooks/usePerformanceMeasure';

// ##### Komarov 2025-07-14
const HomePage = () => {
  // ##### Komarov 2025-08-27
  const componentDevMode = useSelector(state => state.devMode);
  // ##### Komarov 2025-08-27
  // Use the performance measurement hook
  usePerformanceMeasure('HomePage', {
    logToConsole: true,
    componentDevMode,
    onMeasure: (result) => {
      // You can add additional analytics or logging here
      console.log(`📊 Performance data for HomePage (${result.environment}):`, result);

      // Example: Send to analytics
      // analytics.track('component_performance', {
      //   ...result,
      //   page: typeof window !== 'undefined' ? window.location.pathname : 'server'
      // });
    }
  });
  // ##### Komarov 2025-07-28
  const locale = useSelector(state => state.language);
  const deviceType = useSelector(selectDeviceType);
  // ##### 23-02-21 Komarov: Оказывается, чтобы отображались ТопТуры, состояние toggler_type нужно брать именно из state
  // ##### 24-09-10 Komarov
  // const toggler_type = useSelector((state) => state.tophotels.toggler_type);

  const dispatch = useDispatch();
  // ##### 25-03-26 Komarov
  // const purepages = useSelector((state) => state.pages.loadedpages);

  // 199 - id SitePage, которая относится к Слайдеру
  // ##### 25-04-18 Komarov
  const loadedpages = useSelector(state => state.pages.loadedpages);
  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### Komarov 2025-07-28
    if (!loadedpages[199]) {
      // ##### 25-04-30 Komarov
      uniLog(
        'axios:src/Components/Pages/PageComponents/HomePage/HomePage.js:getPurePage(199,deviceType)'
      );
      dispatch(
        getLoadedPage({
          spid: 199,
          deviceType,
        })
      );
    }
    // ##### 25-03-21 Komarov
  }, [dispatch, deviceType]);

  // ##### 25-04-29 Komarov
  const purePage = loadedpages[199];

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column' }}
      data-component="HomePage"
    >
      { /* ##### Komarov 2025-07-28 */}
      <>
        {purePage
          ?
          <React.Fragment key={uniqueId()}>
            <Media
              lessThan="Mobile-L-425-768"
              style={{ height: '37vw' }}
            >
              <CarouselSlider images={purePage.Image.text} className="SliderTabletPortraitCSS" />
            </Media>
            <Media
              between={['Mobile-L-425-768', 'Laptop-1024-1440']}
              style={{ height: '27vw' }}
            >
              <CarouselSlider images={purePage.Image.text} className="SliderMobilePortraitCSS" />
            </Media>
            <Media
              greaterThanOrEqual="Laptop-1024-1440"
              style={{ height: '27vw' }}
            >
              <CarouselSlider images={purePage.Image.text} className="SliderCSS" />
            </Media>
          </React.Fragment>
          : null}
      </>
    </div>
  );
};

export default HomePage;
